<div class="widget form-group" [class.has-error]="control.invalid">
  <label [attr.for]="id" class="horizontal control-label">
    {{ schema.title }}
    <sp-widget-tooltip [widget]="this"></sp-widget-tooltip>
  </label>
  <input [name]="name" class="text-widget range-widget" [attr.id]="id"
    [formControl]="control" [attr.type]="'range'" [attr.min]="schema.minimum" [attr.max]="schema.maximum" [attr.disabled]="schema.readOnly?true:null" />
  <input *ngIf="schema.readOnly" [attr.name]="name" type="hidden" />
  <span *ngIf="schema.description" class="help-block">{{ schema.description }}</span>
  <sp-widget-error [widget]="this" [errors]="control.errors"></sp-widget-error>
</div>



// WEBPACK FOOTER //
// /var/www/schemas-forms/src/app/widgets/range.widget.html